import React, {Fragment} from 'react';
import CartItem from './CartItem.jsx';

export default function CartItemsList({
    items,
    texts,
    calculatingPriceItems,
    onChangeItemQuantity,
    onDeleteItem,
    isPickUpLocationSelectedDeliveryType,
    page,
    itemHeaderComponentSize
}) {
    // See: NH-1110. Items can be split up and have the same lineItemId (4 available, 2 unavailable). To prevent
    // removal of whole lineitem-rows by deleting only the 2 unavailable, we have to sum up all lineitem quantities by
    // line item id
    const quantityById = {};
    items.forEach((item) => {
        if (quantityById[item.id] === undefined) {
            quantityById[item.id] = item.quantity;
        } else {
            quantityById[item.id] += item.quantity;
        }
    });

    const onDelete = (item, items) =>
        onDeleteItem(item, quantityById[item.id] - item.quantity, items);

    return (
        <section className="cart__article-area">
            {items.map((item) => (
                <Fragment key={item.id}>
                    <CartItem
                        item={item}
                        items={items}
                        texts={texts}
                        isCalculatingPrice={calculatingPriceItems.includes(item.id)}
                        onChangeItemQuantity={onChangeItemQuantity}
                        onDeleteItem={onDelete}
                        isPickUpLocationSelectedDeliveryType={isPickUpLocationSelectedDeliveryType}
                        page={page}
                        itemHeaderComponentSize={itemHeaderComponentSize}
                    />
                    <div className="cart__divider-cell">
                        <div className="cart__divider" />
                    </div>
                </Fragment>
            ))}
        </section>
    );
}
